import request from '@/utils/request'

/**
 * 搜索项目进度列表
 * @param {*} params
 */
export function getProjectInfo(params) {
  return request({
    url: '/projectProgress/getProgressInfo',
    method: 'get',
    params
  })
}
// 项目延期报表
export function getPostInfo(params) {
    return request({
      url: '/projectProgress/getPostponeProgressInfo',
      method: 'get',
      params
    })
}
// 成员进度报表
export function getPersonInfo(params) {
    return request({
      url: '/personProgress/getProgressInfo',
      method: 'get',
      params,
    })
}
// 成员延期报表
export function getPersonPostInfo(params) {
  return request({
    url: '/personProgress/getPostponeProgressInfo',
    method: 'get',
    params
  })
}
// 项目进度报表
export function getProjectList(params) {
  return request({
    url: '/bizTaskDecomposition/costBusiness',
    method: 'get',
    params
  })
}